import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { requestIsAccountPastDue } from 'services/actions/userActions';
import env from '../../utils/env';
import { getCampaignType } from '../../utils/campaign';
import { selectPageTrackingFullData } from '../../selectors/trackingSelector';
import { track } from '../../utils/segment';

import styles from './PastDue.module.css';

const CAMPAIGN = getCampaignType();
const ENTER_BUTTON = CAMPAIGN === 'SHOP' ? 'CONTINUE' : 'ENTER THE SALE';

const Loading = () => (
  <div className={styles.billingIssue}>
    <div className={styles.loading}>
      <div className="fa-3x">
        <i className="fas fa-spinner-third fa-spin" />
      </div>
    </div>
  </div>
);

const BillingIssueContent = ({
  icon,
  title,
  body,
  cta,
  onAfterOpen,
  onClickButton,
}) => {
  useEffect(() => {
    onAfterOpen();
  }, []);

  return (
    <div className={styles.billingIssue}>
      <div>
        <div className={styles.pastDueImage}>
          <i className={icon} />
        </div>
        <div className={styles.pastDueTitle}>{title}</div>
        <div className={styles.pastDueBody}>{body}</div>
      </div>
      <button
        type="button"
        className={styles.pastDueButton}
        onClick={onClickButton}
      >
        {cta}
      </button>
    </div>
  );
};

const BillingIssue = ({
  isAccountPastDueRefetch,
  fetchingIsAccountPastDue,
  trackingData,
  closeModal,
  requestIsAccountPastDue,
}) => {
  const handleTrackActivate = (popupName, popupType, ctaName) => {
    const eventName = 'Activate Pop_up';
    track(eventName, {
      ...trackingData,
      pop_up_name: popupName,
      pop_up_type: popupType,
      cta_name: ctaName,
    });
  };
  const handleTrackClick = (experience, elementName) => {
    const eventName = 'Clicked Element';
    track(eventName, {
      ...trackingData,
      experience,
      element_name: elementName,
    });
  };
  const handleClickUpdate = () => {
    closeModal();
    window.location.href = `https://${env.hostname}/my-account`;
  };
  const handleClickEnter = () => {
    handleTrackClick('Past Due Popup', ENTER_BUTTON);
    closeModal();
    window.location.reload();
  };

  if (fetchingIsAccountPastDue) return <Loading />;

  if (isAccountPastDueRefetch === null)
    return (
      <BillingIssueContent
        icon="far fa-sad-cry"
        title="Billing Issue"
        body="It appears there might have been an issue processing your last payment. Please check your account to proceed."
        cta="CHECK MY ACCOUNT"
        onClickButton={requestIsAccountPastDue}
        onAfterOpen={() =>
          handleTrackActivate(
            'Past Due: Notice',
            'auto_open',
            'CHECK MY ACCOUNT'
          )
        }
      />
    );

  if (isAccountPastDueRefetch)
    return (
      <BillingIssueContent
        icon="far fa-file-invoice-dollar"
        title="Almost There"
        body="Your account has a past due invoice. Please update your billing information to enter the sale."
        cta="UPDATE BILLING INFO"
        onClickButton={handleClickUpdate}
        onAfterOpen={() =>
          handleTrackActivate(
            'Past Due: Almost There',
            'click_open',
            'UPDATE BILLING INFO'
          )
        }
      />
    );

  return (
    <BillingIssueContent
      icon="far fa-laugh-beam"
      title="You're Ready"
      body={
        <>
          <span>Your account is up-to-date!</span>
          <span>Click below to start shopping.</span>
        </>
      }
      cta={ENTER_BUTTON}
      onClickButton={handleClickEnter}
      onAfterOpen={() =>
        handleTrackActivate(
          "Past Due: You're Ready",
          'click_open',
          ENTER_BUTTON
        )
      }
    />
  );
};

function mapStateToProps(state) {
  return {
    isAccountPastDueRefetch: state.userState.isAccountPastDueRefetch,
    fetchingIsAccountPastDue: state.userState.fetchingIsAccountPastDue,
    trackingData: selectPageTrackingFullData(state),
  };
}

export default connect(mapStateToProps, { requestIsAccountPastDue })(
  BillingIssue
);
